import { ToastPositionProp } from '../properties';
import { ToastPositionType } from '../types';

export function getToastPosition(position?: ToastPositionType) {
  if (!position) return '';

  return ToastPositionProp[position];
}
